import {
	initializeFaro,
	getWebInstrumentations,
	type Faro,
	LogLevel
} from '@grafana/faro-web-sdk';
import {getEnvironment, getEnvironmentName} from './get-environment';

let faro: Faro | null = null;

/**
 * Initialize the Grafana Faro browser SDK for telemetry collection.
 */
export function initFaro(): Faro | null {
	if (getEnvironment() === 'D') return null;
	if (faro) return faro;

	try {
		faro = initializeFaro({
			url: 'https://logger.outlaw.app/faro/collect',
			app: {
				name: 'outlaw-practice',
				version: __BUILD_VERSION__,
				environment: getEnvironmentName(),
			},
			sessionTracking: {
				enabled: true,
			},
			instrumentations: [
				...getWebInstrumentations({
					captureConsole: false,
				}),
			],
		});
	}
	catch (err) {
		console.warn('Failed to initialize Faro:', err);
	}

	return faro;
}

/**
 * Get the Faro instance. Returns null if not initialized or in development.
 */
export function getFaro(): Faro | null {
	return faro;
}

/**
 * Set user context on the Faro instance for HIPAA audit trail.
 */
export function setFaroUser(userId: string, firmId: string) {
	if (!faro) return;

	faro.api.setUser({
		id: userId,
		attributes: {firmId},
	});
}

/**
 * Push an error to Faro.
 */
export function pushFaroError(err: Error) {
	if (!faro) return;
	faro.api.pushError(err);
}

/**
 * Push a log message to Faro.
 */
export function pushFaroLog(message: string, level: LogLevel = LogLevel.INFO) {
	if (!faro) return;
	faro.api.pushLog([message], {level});
}
